import React from 'react'
import { Card, CardBody, CardHeader, Col, Container, Row } from 'reactstrap'
import { SearchTable, LoadingStateTable } from './Tablas'

const Seguridad = () => {
  document.title = "Seguridad del Sistema | Siga ERP";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col lg={12}>
              <Card>
                <CardHeader>
                  <h5 className="card-title mb-0">Usuarios</h5>
                </CardHeader>
                <CardBody>
                  <LoadingStateTable />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Seguridad;